import { Fragment } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import StyledStack from '@webclient/components/search-forms/gamification-search/actions/file-attachment/sections/take-a-photo/snaphsot-dialog/styles';

type Props = {
  children: React.ReactNode;
  open: boolean;
  onClose: VoidFunction;
  deleteSnapshot: VoidFunction;
  ActionButtons: React.ReactNode[];
};

export default function SnapshotDialog({
  children,
  onClose,
  open,
  ActionButtons,
}: Props) {
  return (
    <Dialog
      maxWidth={'md'}
      open={open}
      keepMounted
      onClose={onClose}
    >
      <StyledStack>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          {ActionButtons.map((ActionButton, index) => (
            <Fragment key={index}>{ActionButton}</Fragment>
          ))}
        </DialogActions>
      </StyledStack>
    </Dialog>
  );
}
